// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitle {
  color: #6c757d;
  margin: 0 0 20px 0;
  font-size: 14px;
}

h3 {
  font-size: 18px;
  margin-bottom: 15px;
}

.text-muted {
  font-size: 14px;
}

.alert {
  display: flex;
  align-items: center;
  gap: 12px;
}
.alert mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.job-action-buttons {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 120px;
}

.job-action-btn {
  min-width: 120px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  justify-content: center;
  text-align: center;
}

.log-console {
  background: #fff;
  color: #212529;
  font-family: "Cascadia Code", "Consolas", "Courier New", monospace;
  font-size: 12px;
  line-height: 1.55;
  padding: 10px 14px;
  height: 220px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.log-console::-webkit-scrollbar {
  width: 7px;
}
.log-console::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.log-console::-webkit-scrollbar-thumb {
  background: #ced4da;
  border-radius: 4px;
}

.log-line {
  padding: 1px 0;
  word-break: break-word;
  white-space: pre-wrap;
}

.log-placeholder {
  color: #adb5bd;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-config/ai-config.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;EACA,kEAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAAF;AAEE;EAAuB,UAAA;AACzB;AAAE;EAA6B,mBAAA;AAG/B;AAFE;EAA6B,mBAAA;EAAqB,kBAAA;AAMpD;;AAHA;EACE,cAAA;EACA,sBAAA;EACA,qBAAA;AAMF;;AAHA;EACE,cAAA;EACA,kBAAA;AAMF","sourcesContent":[".subtitle {\n  color: #6c757d;\n  margin: 0 0 20px 0;\n  font-size: 14px;\n}\n\nh3 {\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n\n.text-muted {\n  font-size: 14px;\n}\n\n.alert {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.job-action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 120px;\n}\n\n.job-action-btn {\n  min-width: 120px;\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  justify-content: center;\n  text-align: center;\n}\n\n.log-console {\n  background: #fff;\n  color: #212529;\n  font-family: 'Cascadia Code', 'Consolas', 'Courier New', monospace;\n  font-size: 12px;\n  line-height: 1.55;\n  padding: 10px 14px;\n  height: 220px;\n  overflow-y: auto;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n\n  &::-webkit-scrollbar { width: 7px; }\n  &::-webkit-scrollbar-track { background: #f1f1f1; }\n  &::-webkit-scrollbar-thumb { background: #ced4da; border-radius: 4px; }\n}\n\n.log-line {\n  padding: 1px 0;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.log-placeholder {\n  color: #adb5bd;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
